import Icon from "components/Icon"

import { NextButton, PrevButton } from "./styled"

export interface CarouselArrowsProps {
  readonly canGoNext: boolean
  readonly canGoPrev: boolean
  readonly isShowArrows: boolean
  readonly isShowThumbnails: boolean
  readonly onNext: () => void
  readonly onPrev: () => void
}

const CarouselArrows = ({
  canGoNext,
  canGoPrev,
  isShowArrows,
  isShowThumbnails,
  onNext,
  onPrev
}: CarouselArrowsProps) => {
  if (!isShowArrows) return null

  return (
    <>
      <PrevButton
        $isShowThumbnails={isShowThumbnails}
        disabled={!canGoPrev}
        icon={<Icon group="io5" name="IoChevronBack" size="30px" />}
        iconOnly
        label="Prev"
        noHoverHighlight
        onClick={onPrev}
      />

      <NextButton
        $isShowThumbnails={isShowThumbnails}
        disabled={!canGoNext}
        icon={<Icon group="io5" name="IoChevronForward" size="30px" />}
        iconOnly
        label="Next"
        noHoverHighlight
        onClick={onNext}
      />
    </>
  )
}

export default CarouselArrows
